const deviceType = {
  Android: 'Android',
  iOS: 'iOS',
  PC: 'PC'
}

export default deviceType
